import styled from 'styled-components';

import { RadiusConfig, neutral, neutralTrans } from 'enable-ui';

export const ActionBtnDelete = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: ${RadiusConfig.xxs}px;
  background-color: ${neutral['neutral-1']};
  border: 1px solid ${neutralTrans['neutralTrans-15']};
`;

export const CustomAvatar = styled.div`
  position: relative;
  .es-avt-upload {
    width: 92px !important;
    height: 92px !important;
    position: absolute;
  }

  .es-avt-img {
    border-radius: 50%;
  }

  .es-file-upload {
    border-radius: 50%;
  }

  .avt-upload-overlay:hover {
    border-radius: 50%;
  }
`;

export const CustomSwitch = styled.div`
  display: flex;
  align-items: center;
  .disabled {
    .slider {
      cursor: default;
    }
  }
`;
